import type { JSX } from 'react'
import type { IBrandContainer } from 'blocks/BrandContainer'
import type { IAuthLayoutProps } from '../AuthLayout'

import { Children } from 'react'
import { SignInAuthFormBox } from 'blocks/AuthFormBox/Templates'
import { BrandContainerDefault } from 'blocks/BrandContainer/Templates'
import { AuthLayout } from '../AuthLayout'

export interface IAuthLayoutTemplateProps extends IAuthLayoutProps {
  brandPosterUrl?: IBrandContainer['logoUrl']
}

export const AuthLayoutTemplate = ({
  children,
  brandPosterUrl = '',
  overlayEnabled = true,
  overlayWidth = 60,
  overlayHeight = 50,
  ...rest
}: IAuthLayoutTemplateProps): JSX.Element => (
  <AuthLayout
    overlayEnabled={overlayEnabled}
    overlayWidth={overlayWidth}
    overlayHeight={overlayHeight}
    {...rest}
  >
    <BrandContainerDefault logoUrl={brandPosterUrl} />
    {Children.count(children) ? children : <SignInAuthFormBox />}
  </AuthLayout>
)
